import axios from "axios";
import {
  GET_ALL_DOCUMENTCHECKLIST_BY_FORMID,
  GET_DOCUMENT_VERIFICATION_STATUS_BY_STUDENT
} from "./types";
const keys = require("../config/keys");

export const getAllDocumentChecklistByFormId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllDocumentChecklistByFormId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_DOCUMENTCHECKLIST_BY_FORMID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getDocumentVerificationStatusByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetDocumentVerificationStatusByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_DOCUMENT_VERIFICATION_STATUS_BY_STUDENT,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllDocumentChecklistByFormId.js